import { CalculateOffsetRight } from 'utils/CalculateOffsetRight';

const Layout = {
  el: {
    root: document.querySelector<HTMLElement>('.layout'),
    left: document.querySelector<HTMLElement>('.layout__left'),
    right: document.querySelector<HTMLElement>('.layout__right'),
    content: document.querySelector<HTMLElement>('.layout__right-content'),
    offsetElement: document.querySelector<HTMLElement>('.footer__inner'),
  },
  init() {
    if (this.el.root) {
      // this.handleOffsets()
      // this.handleResize()
    }
  },
  handleOffsets() {
    this.el.left.style.paddingLeft = `${this.el.offsetElement.offsetLeft}px`;

    if (this.el.content) {
      this.el.content.style.paddingRight = `${CalculateOffsetRight(this.el.offsetElement)}px`;
    }
  },
  handleResize() {
    window.addEventListener('resize', () => {
      this.handleOffsets()
    })
  },
}

export default Layout
